import React, { useEffect } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { trimmedString } from "../../../utils/truncateText";
import { useDeleteVideoMutation, useUpdateVideoMutation } from "../../../features/videos/videosApi";

const MySwal = withReactContent(Swal);

const Video = ({ video }) => {
  const { id, title,duration,url, description } = video || {};

  const [updateVideo, { isLoading: updateLoading, isSuccess: updateIsSuccess }] =
    useUpdateVideoMutation();
  const [deleteVideo, { isLoading:deleteLoading,isSuccess: deleteSuccess }] = useDeleteVideoMutation();

  useEffect(() => {
    if (!deleteLoading && deleteSuccess) {
      MySwal.fire({
        icon: "success",
        title: "<span class='text-white'>Video deleted successfully</span>",
        background: "#080E1B",
        showConfirmButton: false,
        timer: 1500,
      });
    }

    if (!updateLoading && updateIsSuccess) {
      MySwal.fire({
        icon: "success",
        title: "<span class='text-white'>Video updated successfully</span>",
        background: "#080E1B",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }, [deleteSuccess, deleteLoading, updateIsSuccess, updateLoading])

  const handleEditVideo = () => {
    MySwal.fire({
      // title: title,
      width: 800,
      showCancelButton: true,
      confirmButtonText: "Save",
      showLoaderOnConfirm: true,
      background: "#080E1B",
      inputValidator: (value) => {
        if (!value) {
          return "You need to write something!";
        }
      },
      html: `
      <div class="flex flex-col gap-y-2">
        <label for="title" class="text-white text-left mb-3 font-semibold">Title</label>
        <input id="title" class="input input-bordered input-primary w-full text-white" placeholder="Enter title here" value="${title}" />
        <label for="url" class="text-white text-left my-3 font-semibold">Video URL</label>
        <input required id="url" placeholder="Enter embeded video link from youtube" class="input input-bordered input-primary w-full text-white" value="${url}" />
        <label for="duration" class="text-white text-left my-3 font-semibold">Video Duration</label>
        <input required id="duration" placeholder="Enter video duration" class="input input-bordered input-primary w-full text-white" value="${duration}" />
        <label for="description" class="text-white text-left my-3 font-semibold">Description</label>
        <textarea id="description" class="textarea textarea-primary text-white h-28" placeholder="Enter description here" >${description}</textarea>
      </div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        return {
          title: document.getElementById("title").value,
          url: document.getElementById("url").value,
          duration: document.getElementById("duration").value,
          description: document.getElementById("description").value,
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
      const { title, url, duration, description } = result.value;
      if (!title || !url || !duration || !description) {
        MySwal.fire({
          icon: "error",
          title: "<span class='text-white'>Oops...</span>",
          text: "All fields are required",
          background: "#080E1B",
        });
        return;
      }
        updateVideo({
          id,
          title,
          description,
          url,
          duration,
        });
      }
    });
  };

  const handleDeleteVideo = () => {
    deleteVideo(id)
  }

  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">{trimmedString(description, 65)}...</td>
      <td className="table-td flex gap-x-2">
        <svg
          onClick={handleDeleteVideo}
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-6 h-6 hover:text-red-500 cursor-pointer transition-all"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
          />
        </svg>
        <svg
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-6 h-6 hover:text-blue-500 cursor-pointer transition-all"
          onClick={handleEditVideo}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
          />
        </svg>
      </td>
    </tr>
  );
};

export default Video;
